import {Component, OnInit, ViewChild} from '@angular/core';
import {QueryService} from './query.service';
import {MatPaginator, MatTableDataSource} from '@angular/material';
import {MessageService} from '../messages/message.service';
import {TranslateService} from '../shared/translate.service';
import {HtmlUtilsService} from '../html-utils/html-utils.service';
import {environment} from '../../environments/environment';


@Component({
  selector: 'app-query',
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss']
})

export class QueryComponent implements OnInit {
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    if(this.dataReady ) this.dataSource.paginator = value;
  }

  public queryInput;
  public heads: string[] = ["subject", "predicate", "object"];
  public examples;
  public dataSource;
  public dataReady: boolean = false;
  public errorMessage;
  public inProgress: boolean = false;
  public editorOptions
  public env;
  code: string;

  constructor(private htmlUtils: HtmlUtilsService, private queryService: QueryService, private messageService: MessageService, private translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.htmlUtils.contrast ? this.editorOptions = {theme: 'vs-dark', language: 'sql', minimap:{enabled:false}, contextmenu:false, find:false, scrollbar:{vertical: 'hidden'}} :
      this.editorOptions = {theme: 'vs-light', language: 'sql', minimap:{enabled:false}, contextmenu:false, find:false, scrollbar:{vertical: 'hidden'}} ;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value) {
        this.editorOptions = { ...this.editorOptions, theme: 'vs-dark' };
      } else {
        this.editorOptions = { ...this.editorOptions, theme: 'vs-light' };
      }
    });
    this.queryService.getQueryExamples().subscribe(data => {
      this.examples = data.queries;
    });
    this.env = environment;
  }


  sendQuery() {
    this.dataReady = false;
    this.inProgress = true;
    this.errorMessage = null;
    this.queryService.sendQuery(this.queryInput).subscribe((response) => {
      this.dataReady = true;
      this.heads = response.head.vars;
      this.inProgress = false;
      this.dataSource = new MatTableDataSource(response.results.bindings);
    },(error) => {
      this.inProgress = false;
      this.errorMessage = error.error;
    });
    }

  loadExampleToEditor(example) {
    this.queryInput = example;
    this.messageService.successMessage( 'UserQuery.toast.title' , 'UserQuery.toast.message');
  }

  checkIfLink(string) {
    const pattern = /^((http|https):\/\/)/;
    return pattern.test(string);
  }
}
